import { Section } from "collections/Section";
import React from "react";
import { useTranslation } from "utilities/i18n";
import { DetailProps } from "./DeviceDetails";
import { GroupMembership } from "./GroupMembership/GroupMembership";

export const DeviceGroupInheritance: React.FC<DetailProps & {
  showChecks?: boolean;
}> = props => {
  const { t } = useTranslation();
  return (
    <Section className="mb-4">
      <Section.Header>{t("GROUP_MEMBERSHIP")}</Section.Header>
      <GroupMembership {...props} />
    </Section>
  );
};
